'use client';

import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import { Navigation } from 'swiper/modules';

import ArrowNavigationNext from '@/app/_components/Swiper/ArrowNavigationNext';
import ArrowNavigationPrev from '@/app/_components/Swiper/ArrowNavigationPrev';
import { cn } from '@/app/_helper/tailwind';
import { PreferredCurrency, Property } from '@/modules/core/gql/generated';

import SpecialOfferBannerWithText from './SpecialOfferBannerWithText';
import SpecialOfferLoader from './SpecialOfferLoader';
import SpecialOfferRecommendationCard from './SpecialOfferRecommendationCard';

const SpecialOfferRecommendation = ({
    properties,
    redirect,
    isNpl,
    preferredCurrency,
}: {
    properties: Property[] | null;
    redirect: string;
    isNpl: boolean;
    preferredCurrency?: PreferredCurrency | undefined;
}) => {
    const [isBeginningOfSlide, setBeginningOfSlide] = useState(true);
    if (properties && properties?.length < 4) {
        return null;
    }
    return (
        <div className='md:flex items-center md:pb-8 pb-0'>
            <SpecialOfferBannerWithText isNpl={isNpl} redirect={redirect} />
            <div className='relative md:w-[calc(100%-235px)] md:top-0 -top-8 md:-left-[71px] md:bg-white bg-transparent md:ml-0 -mx-4'>
                <ArrowNavigationPrev
                    className={cn(
                        'prev-slider-special-offer border border-solid border-slate-300 shadow-md rounded-full bg-white absolute -translate-y-1/2 top-[55%] md:top-1/2 left-4 md:-left-5 z-[3] w-10 h-10',
                    )}
                />
                <ArrowNavigationNext
                    className={cn(
                        'next-slider-special-offer border border-solid border-slate-300 shadow-md rounded-full bg-white absolute -translate-y-1/2 top-[55%] md:top-1/2 right-4 md:-right-5 z-[3] w-10 h-10',
                    )}
                />
                <Swiper
                    className={cn({
                        '!pr-8 md:!pr-2 md:!pb-8 md:-mb-8 !pb-6 -mb-6 md:!pl-0 !pl-8 !pt-2 md:!pt-0': true,
                        'md:!-ml-6': isBeginningOfSlide,
                    })}
                    wrapperClass={cn({
                        'md:pl-6': isBeginningOfSlide,
                    })}
                    modules={[Navigation]}
                    slidesPerView='auto'
                    spaceBetween={16}
                    onSlideChange={({ isBeginning }) => {
                        setBeginningOfSlide(isBeginning);
                    }}
                    onInit={({ isBeginning }) => {
                        setBeginningOfSlide(isBeginning);
                    }}
                    navigation={{
                        nextEl: '.next-slider-special-offer',
                        prevEl: '.prev-slider-special-offer',
                        disabledClass: 'hidden',
                    }}
                >
                    {properties && properties?.length > 0 && (
                        <>
                            {properties.map((property, index) => {
                                return (
                                    <SwiperSlide
                                        key={`${property.originId?.value}-${index}`}
                                        className='!w-[300px] !h-auto'
                                    >
                                        <SpecialOfferRecommendationCard
                                            property={property}
                                            position={index}
                                            preferredCurrency={
                                                preferredCurrency
                                            }
                                            className={cn({
                                                "[&_[data-name='price-info']]:flex-row [&_[data-name='price-info']]:flex-wrap":
                                                    Boolean(property.priceDrop),
                                            })}
                                        />
                                    </SwiperSlide>
                                );
                            })}
                        </>
                    )}
                    {!properties &&
                        [1, 2, 3]?.map((item) => (
                            <SwiperSlide key={item} className='!w-[300px]'>
                                <SpecialOfferLoader />
                            </SwiperSlide>
                        ))}
                </Swiper>
                {!isBeginningOfSlide && (
                    <div className='md:block hidden absolute left-0 top-0 bottom-0 w-10 bg-[linear-gradient(90deg,#FFF_0%,rgba(255,255,255,0)_100%)] z-[2]' />
                )}
            </div>
        </div>
    );
};

export default SpecialOfferRecommendation;
